import { BrowserRouter } from "react-router-dom";
import { appBaseName } from "utils/common";

/**
 * Provider Component
 *
 * Initializing Router for Application
 *
 * @export
 * @param {*} {children}
 * @return {*}
 */
export default function RouterProvider({ children }) {
  return <BrowserRouter basename={appBaseName}>{children}</BrowserRouter>;
}
